import React, { useContext } from "react";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import productionSheetContext from "../../../store/productionSheetContext";

const WeldingDetailsForm = () => {
  const { weldingInput, setWeldingInput, notes, setNotes, responseDataOutput } =
    useContext(productionSheetContext);

  const { piecesPerHourOutput, hoursWelding } =
    responseDataOutput?.weldingOutput || {};

  // Funzione per aggiornare i valori numerici
  const handleChange = (e) => {
    const { name, value } = e.target;
    setWeldingInput((prev) => ({
      ...prev,
      [name]: parseFloat(value) || 0,
    }));
  };

  // Funzione per aggiornare il tipo di saldatura
  const handleChangeWeldingType = (e) => {
    const newWeldingType = e.target.value;

    setWeldingInput((prev) => ({
      ...prev,
      weldingType: newWeldingType,
      pcsPerHour: newWeldingType === "1" ? prev.pcsPerHour : 0,
      strokesPerHour: newWeldingType === "2" ? prev.strokesPerHour : 0,
      kilogramsPerHour: newWeldingType === "3" ? prev.kilogramsPerHour : 0,
    }));
  };

  // Funzione per determinare il campo da mostrare in base al tipo di saldatura
  const renderWeldingTypeFields = () => {
    switch (weldingInput?.weldingType) {
      case "1":
        return (
          <InputGroup className="mb-2 d-flex">
            <Form.Label className="w-50">Pieces per hour</Form.Label>
            <Form.Control
              className="text-end"
              type="number"
              placeholder="Pieces per hour"
              name="pcsPerHour"
              value={weldingInput?.pcsPerHour || 0}
              onChange={handleChange}
            />
            <InputGroup.Text>Pcs</InputGroup.Text>
          </InputGroup>
        );
      case "2":
        return (
          <InputGroup className="mb-2 d-flex">
            <Form.Label className="w-50">Strokes per hour</Form.Label>
            <Form.Control
              className="text-end"
              type="number"
              placeholder="Strokes per hour"
              name="strokesPerHour"
              value={weldingInput?.strokesPerHour || 0}
              onChange={handleChange}
            />
            <InputGroup.Text>N</InputGroup.Text>
          </InputGroup>
        );
      case "3":
        return (
          <InputGroup className="mb-2 d-flex">
            <Form.Label className="w-50">Kilograms per hour</Form.Label>
            <Form.Control
              className="text-end"
              type="number"
              placeholder="Kilograms per hour"
              name="kilogramsPerHour"
              value={weldingInput?.kilogramsPerHour || 0}
              onChange={handleChange}
            />
            <InputGroup.Text>Kg</InputGroup.Text>
          </InputGroup>
        );
      default:
        return <p>Nessun tipo di saldatura selezionato</p>;
    }
  };

  // Funzione per cambiare le notes
  const handleNotesChange = (e) => {
    const input = e.target.value;

    if (input.length <= 200) {
      setNotes((prevNotes) => ({
        ...prevNotes,
        weldingNotes: input,
      }));
    }
  };

  return (
    <>
      <Card className="mb-5">
        <Card.Header>
          <Card.Title>Welding details</Card.Title>
        </Card.Header>
        <Card.Body>
          <InputGroup className="mb-2 d-flex">
            <Form.Label className="w-50">Welding setup hours</Form.Label>
            <Form.Control
              className="text-end"
              type="number"
              placeholder="Welding setup hours"
              name="weldingSetupHours"
              value={weldingInput?.weldingSetupHours || ""}
              onChange={handleChange}
            />
            <InputGroup.Text>H</InputGroup.Text>
          </InputGroup>

          <hr />

          {/* Selezione tipo di saldatura */}
          <Form.Select
            name="usePcsPerHour"
            className="mb-2"
            value={weldingInput?.weldingType}
            onChange={handleChangeWeldingType}
          >
            <option value="1">Pieces per hour</option>
            <option value="2">Strokes per hour</option>
            <option value="3">Kilograms per hour</option>
          </Form.Select>

          {/* Mostra il campo corretto in base al tipo di saldatura */}
          {renderWeldingTypeFields()}

          <InputGroup className="mb-2 d-flex">
            <Form.Label className="w-50">Number of tracks</Form.Label>
            <Form.Control
              className="text-end"
              type="number"
              placeholder="Number of tracks"
              name="numberOfTracksWelding"
              value={weldingInput?.numberOfTracksWelding || 1}
              onChange={handleChange}
            />
            <InputGroup.Text>N</InputGroup.Text>
          </InputGroup>

          <hr />

          <InputGroup className="mb-2 d-flex">
            <Form.Label className="w-50">Pieces per hour</Form.Label>
            <Form.Control
              className="text-end"
              type="number"
              placeholder="Pieces per hour"
              name="piecesPerHourOutput"
              value={
                typeof piecesPerHourOutput === "number"
                  ? piecesPerHourOutput.toFixed(0)
                  : 0
              }
              disabled
              readOnly
            />
            <InputGroup.Text>Pcs</InputGroup.Text>
          </InputGroup>

          <InputGroup className="mb-2 d-flex">
            <Form.Label className="w-50">Total welding time</Form.Label>
            <Form.Control
              className="text-end"
              type="number"
              placeholder="Total welding time"
              name="hoursWelding"
              value={
                typeof hoursWelding === "number" ? hoursWelding.toFixed(1) : 0
              }
              disabled
              readOnly
            />
            <InputGroup.Text>H</InputGroup.Text>
          </InputGroup>

          <hr />
          <Form.Group>
            <Form.Label>Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              maxLength={200}
              placeholder="Max 200 characters"
              name="weldingNotes"
              value={notes?.weldingNotes || ""}
              onChange={handleNotesChange}
            />
            <Form.Text muted>
              {200 - (notes?.weldingNotes?.length || 0)} characters left
            </Form.Text>
          </Form.Group>
        </Card.Body>
      </Card>
    </>
  );
};

export default WeldingDetailsForm;
